import { render, staticRenderFns } from "./crm-rank-card.vue?vue&type=template&id=5ae491e5&scoped=true"
import script from "./crm-rank-card.vue?vue&type=script&lang=js"
export * from "./crm-rank-card.vue?vue&type=script&lang=js"
import style0 from "./crm-rank-card.vue?vue&type=style&index=0&id=5ae491e5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae491e5",
  null
  
)

export default component.exports